/* @ngInject */
export default function NvMin(
  _,
  BigNumber,
) {
  return {
    require: 'ngModel',
    link(scope, elem, attr, ngModel) {
      // For DOM -> model validation
      ngModel.$parsers.push((value) => {
        if (value != null) {
          const minVal = new BigNumber(attr.min);
          value = new BigNumber(value);
          const valid = value.greaterThanOrEqualTo(minVal);

          ngModel.$setValidity('min', valid);
        } else {
          ngModel.$setValidity('min', true);
        }

        return value;
      });

      // //For model -> DOM validation
      // ngModel.$formatters.push(function(value) {
      //   var valid = value >= -5;
      //   ngModel.$setValidity('min', valid);

      //   return value;
      // });
    },
  };
}
